import { render, staticRenderFns } from "./EmailSmsLogView.vue?vue&type=template&id=189c72ba"
import script from "./EmailSmsLogView.vue?vue&type=script&lang=js"
export * from "./EmailSmsLogView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('189c72ba')) {
      api.createRecord('189c72ba', component.options)
    } else {
      api.reload('189c72ba', component.options)
    }
    module.hot.accept("./EmailSmsLogView.vue?vue&type=template&id=189c72ba", function () {
      api.rerender('189c72ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/emailsmslog/EmailSmsLogView.vue"
export default component.exports